export const TEST_IDS = {
    table: { id: 'substances-table' },
    editSubstanceFields: {
        substance: 'newSubstance-input-substance',
        workPositionAndSector: 'newSubstance-input-workPositionAndSector',
        comercialName: 'newSubstance-input-comercialName',
        usageOrigin: 'newSubstance-input-usageOrigin',
        employmentMethods: 'newSubstance-input-employmentMethods',
        substanceAnualQuantity: 'newSubstance-input-substanceAnualQuantity',
        measureUnit: 'newSubstance-input-measureUnit',
        report: 'newSubstance-input-report',
        trainingProgram: 'newSubstance-input-trainingProgram',
        studiesAndReplacementPosibility: 'newSubstance-input-studiesAndReplacementPosibility',
        specialLicense: 'newSubstance-input-specialLicense',
        preventiveMeasures: 'newSubstance-input-preventiveMeasures',
        protectiveEquipment: 'newSubstance-input-protectiveEquipmen'
    },
    newStudyFields: {
        type: 'newStudy-input-type',
        detail: 'newStudy-input-detail',
        frequency: 'newStudy-input-frequency',
        frequencyQuantity: 'newStudy-input-frequencyQuantity'
    },
    buttons: {
        submit: 'main-button-submit',
        cancel: 'main-button-cancel'
    }
};